// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jx-0";
export var discountCodeInput = "_jx-1";